<app-confirm-dialog
  [visible]="true"
  [wide]="true"
  icon="drive_file_rename_outline"
  confirmColor="primary"
  [title]="(isLibrary() ? 'objectMappings.rename.titleLibrary' : 'objectMappings.rename.titleEntry') | translate"
  [message]="'objectMappings.rename.message' | translate: { name: currentName() }"
  [confirmLabel]="'objectMappings.rename.confirm' | translate"
  [cancelLabel]="'objectMappings.rename.cancel' | translate"
  [busy]="applying()"
  [confirmDisabled]="!canApply()"
  (confirmed)="apply()"
  (cancelled)="cancelled.emit()"
>
  <form class="ord-form" (submit)="$event.preventDefault(); loadPreview()">
    <mat-form-field appearance="fill" floatLabel="always" class="ord-field tc-field tc-field--uppercase-label">
      <mat-label>{{ 'objectMappings.rename.newName' | translate }}</mat-label>
      <input
        #nameInput
        matInput
        data-testid="ord-name"
        autocomplete="off"
        [value]="name()"
        [attr.maxlength]="fieldLengths.NAME_MAX"
        [attr.aria-invalid]="showInvalid()"
        [attr.aria-describedby]="showInvalid() ? 'ord-invalid' : null"
        (input)="onNameInput($event)"
      />
    </mat-form-field>
    <button mat-stroked-button type="submit" class="ord-preview" data-testid="ord-preview" [disabled]="!canPreview()">
      {{ 'objectMappings.rename.preview' | translate }}
    </button>
  </form>
  @if (showInvalid()) {
    <p id="ord-invalid" class="ord-hint ord-hint--error" data-testid="ord-invalid">
      {{ 'objectMappings.rename.invalidName' | translate }}
    </p>
  }

  @if (previewLoading()) {
    <div class="ord-loading" data-testid="ord-loading" role="status">
      <mat-spinner diameter="24" />
      <span>{{ 'objectMappings.rename.previewLoading' | translate }}</span>
    </div>
  }
  @if (error(); as message) {
    <p class="ord-hint ord-hint--error" role="alert" data-testid="ord-error">{{ message }}</p>
  }

  @if (preview(); as result) {
    @if (isLibrary()) {
      <div class="ord-warning" role="alert" data-testid="ord-library-warning">
        <strong class="ord-warning__count">{{ result.occurrenceCount }}</strong>
        <span>{{ 'objectMappings.rename.libraryWarning' | translate }}</span>
      </div>
    }
    <dl class="ord-summary" data-testid="ord-summary">
      <div class="ord-summary__item">
        <dt>{{ 'objectMappings.rename.occurrences' | translate }}</dt>
        <dd>{{ result.occurrenceCount }}</dd>
      </div>
      <div class="ord-summary__item">
        <dt>{{ 'objectMappings.rename.testCases' | translate }}</dt>
        <dd>{{ result.testCaseCount }}</dd>
      </div>
      <div class="ord-summary__item">
        <dt>{{ 'objectMappings.rename.modules' | translate }}</dt>
        <dd>{{ result.moduleCount }}</dd>
      </div>
    </dl>
    <app-object-usage-list class="ord-usages" [usages]="result.usages" [projectId]="projectId()" />
    @if (result.notTouched.length > 0) {
      <div class="ord-not-touched" data-testid="ord-not-touched">
        <p class="ord-hint">{{ 'objectMappings.rename.notTouched' | translate }}</p>
        <ul class="ord-not-touched__lines">
          @for (line of result.notTouched; track $index) {
            <li>
              @if (line.lineNumber !== null) {
                <span class="ord-not-touched__number">
                  {{ 'objectMappings.usages.line' | translate }} {{ line.lineNumber }}
                </span>
              }
              <code>{{ line.text ?? line.reference }}</code>
            </li>
          }
        </ul>
      </div>
    }
  }
</app-confirm-dialog>
